import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export type ReportTab = 'daily' | 'performance' | 'compliance' | 'all';

const VALID_TABS: ReportTab[] = ['daily', 'performance', 'compliance', 'all'];

/**
 * Hook to manage report tab state with URL persistence
 */
export function useReportsTabs() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromUrl = searchParams.get('tab') as ReportTab | null;
  const [activeTab, setActiveTab] = useState<ReportTab>(tabFromUrl || 'daily');

  // Sync tab to URL
  const handleTabChange = (tab: ReportTab) => {
    setActiveTab(tab);
    const newParams = new URLSearchParams(searchParams);
    if (tab === 'daily') {
      newParams.delete('tab'); // Default tab doesn't need URL param
    } else {
      newParams.set('tab', tab);
    }
    setSearchParams(newParams, { replace: true });
  };

  // Sync from URL on mount/change
  useEffect(() => {
    if (tabFromUrl && VALID_TABS.includes(tabFromUrl)) {
      setActiveTab(tabFromUrl);
    }
  }, [tabFromUrl]);

  return { activeTab, setActiveTab: handleTabChange };
}

